<template>
    <div class="flex box-border">
        <div class="deliveryAddressCard__action w-8/12">
            <p class="no-margin" v-text="$t(`${headingKey}`)"></p>
        </div>
        <div class="deliveryAddressCard__action w-4/12 border-l">
            <p v-if="hasDiscount && actualPrice != discountedPrice" class="p-0 m-0 text-center w-full" :class="{'strike-through': hasDiscount}">
                £{{actualPrice}}
            </p>
            <p class="p-0 m-0 text-center w-full" v-text="netPrice"/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DeliveryPriceStrike',
    props: {
        actualPrice: {
            required: true,
            type: Number,
        },
        discountedPrice: {
            type: Number,
        },
        headingKey: {
            required: true,
            type: String,
        },
    },
    computed: {
        hasDiscount() {
            return this.discountedPrice;
        },
        netDiscountedPrice() {
            if (this.discountedPrice === this.actualPrice) return this.$t('SHOP_FREE');
            return `£${this.discountedPrice}`;
        },
        netPrice() {
            let netDiscountPrice = this.actualPrice - this.discountedPrice;

            return this.discountedPrice ? (netDiscountPrice == 0 ? this.netDiscountedPrice : `£${netDiscountPrice}`) : `£${this.actualPrice}`;
        },
    },
};
</script>

<style lang="scss" scoped>
    .box-border {
        border-top: 1px solid #000000;
    }
    .strike-through{
        text-decoration: line-through;
    }
</style>
